import React, { useEffect, useState } from 'react';
import { AUTH_SESSION, AUTH_USERNAME } from '@prosaas/psw-events';
import {
  FullPageSpinner,
  NavLinkDisplay,
  CardForm,
  CardTitle,
  CardFormItem,
  Spacer,
  CardContentSpan,
} from '@prosaas/psw-styleguide';
import { subscribe } from '@prosaas/psw-utils';
import { authTestIds } from '../testIds';
import { apiService } from '../services/api.service';
import { useAuthTranslations } from '../hooks/useAuthTranslations';

const AuthenticatedLandingPage: React.FC = () => {
  const [sessionId, setSessionId] = useState<string | null>(null);
  const [username, setUsername] = useState<string>('??');
  const [isFetching, setIsFetching] = useState<boolean>(true);

  const [translations, isLoadingTranslations] = useAuthTranslations();

  useEffect(() => {
    const unsubscribers = [
      subscribe(AUTH_SESSION, ({ sessionId: newSessionId = null } = {}) => {
        if (newSessionId != sessionId) {
          setSessionId(newSessionId);
          setIsFetching(false);
        }
      }),
      subscribe(AUTH_USERNAME, setUsername),
    ];

    return function cleanUp() {
      for (const unsubscriber of unsubscribers) {
        unsubscriber();
      }
    };
  });

  const HEADER_WELCOME = translations.headerWelcome('Proto Solutions');
  const YOU_ARE_SIGNED_IN_AS = translations.youAreSignedInAs();
  const NOT_YOU = translations.notYou();

  if (isFetching || isLoadingTranslations) {
    return <FullPageSpinner />;
  }

  return (
    <>
      <CardForm>
        <CardTitle testId={authTestIds.dashboardCardTitle}>{HEADER_WELCOME}</CardTitle>
        <Spacer />
        <CardFormItem>
          {YOU_ARE_SIGNED_IN_AS}
          <CardContentSpan>{username}</CardContentSpan>
        </CardFormItem>
        <Spacer />
        <NavLinkDisplay displayName={NOT_YOU} onClick={apiService.logOut} />
      </CardForm>
    </>
  );
};

export default AuthenticatedLandingPage;
